import { CircleFragment } from '../gql'

// Minimal shape needed from OrgData, so the rule can be tested on its own and
// shared by the webapp and the backend — the two must agree, or the screen
// announces a tally the server does not apply.
interface CircleLookup {
  getCircle(id: string | undefined): CircleFragment | undefined
  ownerCircleOf(circle: CircleFragment): CircleFragment | undefined
}

// Which circle's participants decide a proposal (D6, 05/08/2026).
//
// A proposal changes the structure, so it is decided by the circle that
// CONTAINS the object being changed, not by the object itself: the holders of a
// role do not get to redefine their own role, and a circle is defined by
// whoever delegated its perimeter.
//
// One rule covers the three cases, because `ownerCircleOf` already does:
//   - a role      → the circle holding it
//   - a circle    → the circle above it
//   - a link role → the circle it represents (its grandparent)
//
// Fallback on the root circle, which has nothing above it: it decides for
// itself, since the alternative is that nobody can.
//
// Why it matters: before this rule, a proposal carried by a role consulted only
// that role's holders. One of Yocoop's existing proposals was decided by a
// single person.
export function getProposalVoterCircleId(
  orgData: CircleLookup,
  circleId: string
): string {
  const circle = orgData.getCircle(circleId)
  if (!circle) return circleId
  return orgData.ownerCircleOf(circle)?.id ?? circleId
}
